/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import diamondPurple from '../../../assets/gems/diamond_purple.svg?inline';
export function DiamondPurple({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: diamondPurple,
        alt: "DiamondPurpleImage"
    });
}
